
import { FirearmEntityDecoratorBase } from './firearm.decorator.base';


export class FirearmEntityDecorator extends FirearmEntityDecoratorBase {
  constructor() {
    super();
  }
}



